(() => {
  function toggleCard(card, btn) {
    const open = card.classList.toggle('data-overlay');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  // Click to toggle
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.data-onclick-grid');
    if (!btn) return;
    const card = btn.closest('.t4s-feature-onclick__content');
    if (!card) return;
    e.preventDefault();
    toggleCard(card, btn);
  });

  // Keyboard support (Enter/Space)
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const btn = e.target.closest('.data-onclick-grid');
    if (!btn) return;
    const card = btn.closest('.t4s-feature-onclick__content');
    if (!card) return;
    e.preventDefault();
    toggleCard(card, btn);
  });
})();
